
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prizes/[filter]",
      function () {
        return require("private-next-pages/prizes/[filter].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prizes/[filter]"])
      });
    }
  